import type { DashboardOrganization } from '../types';

const getMockOrganizations = (): DashboardOrganization[] => [
    {
        id: 'org_northwind',
        name: 'Northwind Labs',
        status: 'active',
        statusLabel: 'Active',
        revenueCents: 124000,
        costCents: 91820,
        ltvCents: 1488000,
        signal: 'healthy',
        signalLabel: 'Healthy',
    },
    {
        id: 'org_acme',
        name: 'Acme Corp',
        status: 'active',
        statusLabel: 'Active',
        revenueCents: 89000,
        costCents: 23800,
        ltvCents: 1068000,
        signal: 'healthy',
        signalLabel: 'Healthy',
    },
    {
        id: 'org_initech',
        name: 'Initech',
        status: 'active',
        statusLabel: 'Active',
        revenueCents: 64000,
        costCents: 71240,
        ltvCents: 384000,
        signal: 'loss',
        signalLabel: 'Negative margin',
    },
    {
        id: 'org_globex',
        name: 'Globex',
        status: 'past_due',
        statusLabel: 'Past due',
        revenueCents: 0,
        costCents: 38400,
        ltvCents: 0,
        signal: 'loss',
        signalLabel: 'Cost, no revenue',
    },
    {
        id: 'org_umbrella',
        name: 'Umbrella Ops',
        status: 'no_subscription',
        statusLabel: 'No subscription',
        revenueCents: 0,
        costCents: 12600,
        ltvCents: 0,
        signal: 'leak',
        signalLabel: 'Usage · not paying',
    },
    {
        id: 'org_stark',
        name: 'Stark Tools',
        status: 'active',
        statusLabel: 'Active',
        revenueCents: 29000,
        costCents: 9100,
        ltvCents: 348000,
        signal: 'healthy',
        signalLabel: 'Healthy',
    },
];

export default getMockOrganizations;
